'use strict';

angular.module('portal.applications')
    .controller('PortalApplicationsCheckoutPayment', ['$q', '$scope', '$window', '$filter', '$rootScope', 'Payments', 'Regions', 'Resource', 'Format', function ($q, $scope, $window, $filter, $rootScope, Payments, Regions, Resource, Format) {

    }])
;